export const LegalNotes = ({ compact = false }) => (
  <div
    data-testid="legal-notes"
    className={`${compact ? "text-[11px]" : "text-xs"} leading-relaxed text-neutral-400 space-y-4`}
  >
    <div className="sc-overline" style={{ color: "#9a9a9a" }}>
      Note Legali e Trasparenza
    </div>
    <p className="font-medium text-neutral-300">
      Termini del Servizio in breve (SuiteCrowd):
    </p>
    <ol className="space-y-3 list-decimal list-inside">
      <li>
        <span className="text-neutral-300">Natura del Servizio.</span>{" "}
        SuiteCrowd è una piattaforma tecnologica che facilita il pre-acquisto di
        servizi turistici futuri sotto forma di micro-finanziamento collettivo
        (crowdfunding). Non costituisce un'attività di sollecitazione al
        pubblico risparmio o un prodotto finanziario speculativo.
      </li>
      <li>
        <span className="text-neutral-300">Tutela dei Fondi (Conto Escrow).</span>{" "}
        La quota di iscrizione/sostegno di 49,00 € versata dall'utente non viene
        incassata direttamente dalla piattaforma né dall'hotel. I fondi vengono
        depositati e congelati in un conto di garanzia indipendente (gestito
        tramite il fornitore di pagamenti autorizzato Stripe/PayPal).
      </li>
      <li>
        <span className="text-neutral-300">Garanzia di Rimborso.</span> I fondi
        saranno svincolati a favore della struttura alberghiera solo al
        raggiungimento del target di raccolta o all'avanzamento certificato dei
        lavori. Nel caso in cui il progetto dell'hotel venga annullato, o la
        struttura non completi la ristrutturazione nei tempi previsti, la quota
        di 49,00 € verrà interamente riaccreditata sul metodo di pagamento
        originario dell'utente.
      </li>
      <li>
        <span className="text-neutral-300">Utilizzo del Voucher.</span> Il
        voucher garantisce un soggiorno di 4 giorni (camera doppia) per l'anno
        solare successivo al completamento dei lavori, utilizzabile
        esclusivamente nei periodi di bassa e media stagione indicati
        dall'hotel. L'utilizzo in alta stagione o nei ponti festivi è soggetto a
        un supplemento monetario obbligatorio da saldare al momento della
        prenotazione effettiva.
      </li>
    </ol>
  </div>
);
